import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import TableBody from './tableBody';
import TablePaginator from '../../../common/components/tablePaginator';
import ConfirmBeforeChangePageModal from './modal/confirmBeforeChangePage';

class LocationsAssignmentTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'showConfirmModal': false,
      'pageSelected': 0,
    };
    this.onSaveDataOfCurrentPageClick =
      this.onSaveDataOfCurrentPageClick.bind(this);
    this.onPageClick = this.onPageClick.bind(this);
  }

  onSaveDataOfCurrentPageClick(saveData) {
    const {pageSelected, location} = this.state;
    const {selectedWarehouse, pageSize, pageNumber, handleSubmit, handleSearch} = this.props;
    this.setState({'showConfirmModal': false});
    if (saveData) {
      const params = {
        location,
        'limit': pageSize,
        'offset': pageSelected || pageNumber,
      };

      handleSubmit(params);
      return;
    }
    this.props.changeWarehouseAllocationPage(pageSelected);
    handleSearch(pageSelected, selectedWarehouse);
  }

  onPageClick(value) {
    this.setState({
      'showConfirmModal': true,
      'pageSelected': value,
    });
  }

  renderModal() {
    const {showConfirmModal} = this.state;
    if (showConfirmModal) {
      return (
        <ConfirmBeforeChangePageModal
          isOpen={showConfirmModal}
          confirmClick={this.onSaveDataOfCurrentPageClick}
        />
      );
    }
    return null;
  }

  renderLoader(message = '') {
    return (
      <Card raised fluid>
        <Loader active inline='centered'>
          {message}
        </Loader>
      </Card>
    );
  }

  renderLoaderOrTable() {
    const {
      loadingFreeLocations,
      checkingFile,
      loadingExcel,
      submittingAssignments,
    } = this.props;

    if (loadingFreeLocations) {
      return this.renderLoader('Obteniendo ubicaciones libres...');
    }

    if (loadingExcel) {
      return this.renderLoader('Cargando archivo...');
    }

    if (checkingFile) {
      return this.renderLoader('Importando archivo...');
    }

    if (submittingAssignments) {
      return this.renderLoader('Procesando asignación de ubicaciones...');
    }

    return (
      <Table>
        {this.renderHeader()}
        <TableBody />
        {this.renderPagination()}
      </Table>
    );
  }

  renderHeader() {
    return (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Cod. Item</Table.HeaderCell>
          <Table.HeaderCell>Descripción</Table.HeaderCell>
          <Table.HeaderCell>Cant</Table.HeaderCell>
          <Table.HeaderCell>ICC</Table.HeaderCell>
          <Table.HeaderCell>Tránsito</Table.HeaderCell>
          <Table.HeaderCell>Ubicación Anterior</Table.HeaderCell>
          <Table.HeaderCell>Ubicación Actual</Table.HeaderCell>
          <Table.HeaderCell>Ubicaciones Reservadas</Table.HeaderCell>
          <Table.HeaderCell>Ubicación Nueva</Table.HeaderCell>
          <Table.HeaderCell>Ubicación Reserva</Table.HeaderCell>
          <Table.HeaderCell></Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    );
  }

  renderPagination() {
    const {pageNumber, pageSize, count} = this.props;

    if (count <= pageSize) {
      return null;
    }

    return (
      <Table.Footer>
        <Table.Row textAlign='center'>
          <Table.HeaderCell colSpan='100%'>
            <div className='table-pagination'>
              <span className='page-sizer'></span>
              <TablePaginator
                itemsCount={count}
                itemsPerPage={pageSize}
                selectedPage={pageNumber}
                onOptionClick={this.onPageClick.bind(this)}
              />
              {this.renderModal()}
            </div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    );
  }

  render() {
    return (
      <Card raised fluid>
        {this.renderLoaderOrTable()}
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'selectedWarehouse': state.locationsAssignment.warehouse,
    'loadingFreeLocations': state.locationsAssignment.loadingFreeLocations,
    'checkingFile': state.locationsAssignment.checkingAssignments,
    'submittingAssignments': state.locationsAssignment.submittingAssignments,
    'count': state.locationsAssignment.count,
    'pageNumber': state.locationsAssignment.offset,
    'pageSize': state.locationsAssignment.limit,
    'loadingExcel': state.excelReader.loading,
  };
};

const {changeWarehouseAllocationPage} = Actions;

export default connect(mapStateToProps, {changeWarehouseAllocationPage})(
  LocationsAssignmentTable
);
